'use client';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { LayoutContainer } from '@/lib/components/Layout/LayoutContainer';
import { CentText } from '@/lib/components/Text/CentText';
import { useMarketPrice } from '@/lib/hooks/useMarketPrice';
import { useOrderFormStore, useSelectedOutcome } from '@/lib/store/order-form-store';
import { EMarketAction } from '@/lib/types/market-action';
import { EMarketIntent } from '@/lib/types/market-intent';
import { Button } from '@/lib/ui-kit/button';
import { cn } from '@/lib/ui-kit/utils';

export const OrderFormTriggerMobile = () => {
  const t = useTranslations('common');

  // CRITICAL FIX: Use specific selectors
  const setAll = useOrderFormStore.use.setAll();
  const selectedOutcomeId = useOrderFormStore.use.selectedOutcomeId();
  const outcome = useSelectedOutcome();

  const yesPrice = useMarketPrice({
    outcomeId: selectedOutcomeId!,
    intent: EMarketIntent.YES,
    action: EMarketAction.BUY,
  });
  const noPrice = useMarketPrice({
    outcomeId: selectedOutcomeId!,
    intent: EMarketIntent.NO,
    action: EMarketAction.BUY,
  });

  const handleYesClick = useCallback(() => {
    setAll({ isMobileFormOpened: true, intent: EMarketIntent.YES });
  }, [setAll]);

  const handleNoClick = useCallback(() => {
    setAll({ isMobileFormOpened: true, intent: EMarketIntent.NO });
  }, [setAll]);

  if (!outcome) {
    return null;
  }

  return (
    <div
      className={cn(
        'fixed bottom-[60px] left-0 z-30 w-screen border-t border-v2-border bg-v2-surface-primary pb-2 min-[1024px]:hidden',
      )}
    >
      <LayoutContainer className="flex h-full justify-center">
        <div className="grid w-full grid-cols-2 gap-2">
          <Button
            className="w-full"
            size="md"
            onClick={handleYesClick}
            variant="contained"
            color="success"
          >
            <span>
              {t('yes')} {yesPrice !== null ? <CentText value={yesPrice} /> : null}
            </span>
          </Button>
          <Button
            className="w-full"
            size="md"
            onClick={handleNoClick}
            variant="contained"
            color="danger"
          >
            <span>
              {t('no')} {noPrice !== null ? <CentText value={noPrice} /> : null}
            </span>
          </Button>
        </div>
      </LayoutContainer>
    </div>
  );
};
